import { Loader } from 'src/design/atoms/Loader';
import { Text } from 'src/design/atoms/Text';
import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useRoleDetail } from 'src/api/queries/organization/useRoleDetail';
import { Header } from 'src/design/organisms/Header';
import { RoleForm } from 'src/routes/Settings/Roles/components/RoleForm';

export const UpdateRole: React.FC = () => {
  const params = useParams<{ id: string }>();
  const { state } = useLocation();
  const listPath = (state as { from?: string })?.from ?? '/settings/roles';
  const { data: role, isLoading: loading } = useRoleDetail(Number(params.id));

  const roleName = loading ? 'Loading...' : role?.name || 'Role';

  return (
    <>
      <Header
        title={roleName}
        helpText="Roles determine access to features through the use of pre-defined scopes. Scopes control what resources a user with a role can read, write, and/or manage."
        breadcrumbProps={{
          items: [
            { text: 'Settings', href: '/settings' },
            { text: 'Roles', href: listPath },
            { text: roleName },
          ],
        }}
      />
      {loading ? (
        <div className="text-center">
          <Loader />
        </div>
      ) : role ? (
        <RoleForm initialValues={role} listPath={listPath} />
      ) : (
        <Text c="dimmed">Role not found.</Text>
      )}
    </>
  );
};
